if (!customElements.get('tsf-preparation-video')) {
  class ThinSlimPreparationVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const button = this.querySelector('[data-demo-description-toggle]');
      const transcript = this.querySelector('[data-demo-transcript]');
      const describedTranscript = this.querySelector('[data-demo-described-transcript]');
      const source = this.video.querySelector('source');
      const track = this.video.querySelector('track');
      if (button && source && track && transcript && describedTranscript) {
        this.original ??= { source: source.getAttribute('src'), track: track.getAttribute('src'), transcript: transcript.innerHTML };
        button.hidden = false;
        button.addEventListener('click', () => {
          const described = button.getAttribute('aria-pressed') !== 'true';
          this.video.pause();
          source.setAttribute('src', described ? button.dataset.describedUrl : this.original.source);
          track.setAttribute('src', described ? button.dataset.describedCaptions : this.original.track);
          transcript.innerHTML = described ? describedTranscript.innerHTML : this.original.transcript;
          button.setAttribute('aria-pressed', String(described));
          this.video.load();
        }, { signal });
      }
      document.addEventListener('play', (event) => {
        if (event.target !== this.video) this.video.pause();
      }, { capture: true, signal });
      this.video.addEventListener('play', () => {
        if (document.hidden) this.video.pause();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) this.video.pause();
        });
        this.observer.observe(this.video);
      }
    }

    disconnectedCallback() {
      this.video?.pause();
      this.controller?.abort();
      this.observer?.disconnect();
    }
  }

  customElements.define('tsf-preparation-video', ThinSlimPreparationVideo);
}
